import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PressKitModule } from '@modules/press-kit/press-kit.module';

import { PressKitPageRoutingModule } from './press-kit-page-routing.module';
import { PressKitPageComponent } from './press-kit-page.component';

@NgModule({
  imports: [CommonModule, PressKitPageRoutingModule, PressKitModule, PressKitPageComponent],
  exports: [PressKitPageComponent],
})
export class PressKitPageModule {}
